<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  props: ['contract', 'work_order_type', 'disabled'],
  mixins: [pagination, tableSearch],
  data() {
    return {
      isLoading: false,
      treatmentContracts: [],
      dataSelected: {},
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = apiEndpoints.projects_sales_treatment_contracts(this.$route.params.id);
      const sendApiProject = await this.$http.get(url);
      const {status, data} = sendApiProject;

      if (status && data.result) {
        this.treatmentContracts = data.result;
        this.dataSelected = this.contract ?? {}
      }
      this.isLoading = false;
    },
    updateValue: function () {
      this.$emit("dataSelected", this.dataSelected);
      this.$bvModal.hide("select-treatment-contracts");
    },
    onClickRow(item) {
      this.dataSelected = item;
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "CB管理番号",
          value: "treatment_contract_cd",
          sortable: true
        },
        {
          text: "契約名",
          value: "treatment_contract_name",
          sortable: true
        }
      ];
    },
    disableButtonContractSelect() {
      return [
        this.$constant.work_order_type.work,
        this.$constant.work_order_type.transportation,
        this.$constant.work_order_type.transshipment_storage,
        this.$constant.work_order_type.others,
      ].includes(this.work_order_type)
    },
  },
  watch: {
    contract: {
      handler: function(val) {
        if (!val) return;
        this.dataSelected = val ?? {}
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.select-treatment-contracts
      class="btn btn-primary waves-effect waves-light"
      :disabled="disableButtonContractSelect || disabled"
    >
      <i class='far fa-list-alt'></i> 処分契約を選択する
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="select-treatment-contracts"
      centered
      title-class="font-18"
      hide-footer
      title="処分契約一覧"
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
            <tr>
              <th>選択</th>
              <th
                v-for="(item, index) in headers"
                :key="index"
                :class="getHeaderClass(item)"
              >
                <span>
                    {{ item.text }}
                  </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(item, index) in treatmentContracts"
              :key="index"
              @click="onClickRow(item)"
              class="cursor-pointer"
            >
              <td class="text-center">
                <label>
                  <b-form-radio
                    class="cursor-pointer"
                    v-model="dataSelected"
                    :value="item"
                  ></b-form-radio>
                </label>
              </td>
              <td>
                {{ item.treatment_contract_cd }}
              </td>
              <td>
                {{ item.treatment_contract_name }}
              </td>
            </tr>
            <tr v-if="!treatmentContracts.length && !isLoading">
              <td :colspan="headers.length" class="text-center">
                データなし。
              </td>
            </tr>
            </tbody>
          </CommonTableComponent>
          <div class="d-flex justify-content-end mt-2">
            <button
              @click="updateValue"
              class="btn btn-primary w-md waves-effect waves-light"
            >
              <i class='fas fa-check'></i> 確定
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
